import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'policy-en',
    templateUrl: './policy-en.component.html',
    styleUrls: ['./policy-en.component.scss']
})
export class PolicyEnComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
